import 'promise/polyfill';
import 'whatwg-fetch';
import React from 'react';
import { render } from 'react-dom';
import AppContainer from './containers';
import '@grpn/mx-components/dist/main.css';

render(<AppContainer />, document.getElementById('root'));

if (module.hot) {
  module.hot.accept('./containers/index.tsx', () => {
    const AppContainer = require('./containers/index.tsx');
    render(<AppContainer />, document.getElementById('root'));
  });
}
